/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetWorkflowStepsRequest = {
  properties: {
    workflowId: {
      type: 'Workflow',
    },
  },
} as const;
